import { IAppState } from '../../../AppModulesWrapper';

import { EMultiPostingAvailablePlatforms } from '../../types/reducers/multiPosting';
import { selectMultipostingABGroup } from './selectMultipostingABGroup';

export const selectMultiPostingAvailablePlatforms = (state: IAppState) => {
  const multipostingABGroup = selectMultipostingABGroup(state);

  if (!multipostingABGroup) {
    return EMultiPostingAvailablePlatforms.None;
  }

  switch (multipostingABGroup) {
    case 'B':
      return EMultiPostingAvailablePlatforms.All;

    case 'C':
      return EMultiPostingAvailablePlatforms.Free;

    default:
      return EMultiPostingAvailablePlatforms.None;
  }
};
